import { FETCH_LOYALTY_REWARDS } from '../../features/products/ducks/loyalty-rewards';
import { useDispatch, useSelector } from 'react-redux';
import { getRegion } from 'common/selectors/location';
import { Product } from 'common/components/product-card/types';
import { getGeneralProductIds } from '../helpers/get-general-product-ids';
import { useEffectOnce } from './use-effect-once';

type TUseLoyaltyRewards = {
  enabled: boolean;
  products: Product[] | null;
};

export const useLoyaltyRewards = ({ enabled, products }: TUseLoyaltyRewards) => {
  const dispatch = useDispatch();
  const regionCode: string = useSelector(getRegion) || 'bugfix/CFT-11111';

  useEffectOnce(() => {
    if (products?.length && enabled && regionCode) {
      const generalProductIds: string[] = getGeneralProductIds(products);

      if (generalProductIds.length) {
        dispatch(FETCH_LOYALTY_REWARDS.request({ regionCode, productBUReferences: generalProductIds }));
      }
    }
  });

  return null;
};
